<ion-app>
  <router-outlet></router-outlet>

  <curbnturf-update></curbnturf-update>
</ion-app>
